import axios from 'axios';
import store from "../store/index";
import tool from "../tool/index";

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头信息。
axios.defaults.headers.common['token'] = sessionStorage.getItem("ms_token");

const service = axios.create({
    // process.env.NODE_ENV === 'development' //来判断是否开发环境
    baseURL: '/CrmApi',
    // baseURL: (process.env.NODE_ENV === 'development') ? 'http://localhost:9815' : '/CrmApi',
    // baseURL: 'http://localhost:9811/WxLogin',
    timeout: 1000000
});
//发送请求前
service.interceptors.request.use(
    function(config)  {
        // console.time("Request")
        // console.timeLog("Request")
        // config.transformRequest = function (data) {
        //     return data;
        // }
        // config.headers.common['token'] = sessionStorage.getItem("ms_token");
        // console.log(config);
        return config;
    },
    function(error)  {
        console.log(error);
        return Promise.reject(error);
    }
);
//收到请求后
service.interceptors.response.use( 
    function(response)  {
        // console.log(response);
        // response.transformResponse = function (data) {
        //     return data;
        // }
        var data=null
        // console.log(response.data);
        // console.log(store.state);
        // console.log(response.data.timeStamp && response.data.timeStamp != "");
        if (response.data.timeStamp && response.data.timeStamp != ""){
            try {
                var token = store.state.tokens[response.data.timeStamp]
                // console.log(response.data.data, token);
                var text = tool.AES_ECB_DECRYPT(response.data.data, token)
                // console.log(text);
                data = JSON.parse(text?text:'{}')
                if (data.timeStamp && data.token){
                    store.commit("addTokens",{ time:data.timeStamp, token:data.token });
                }                
            } catch (error) {
                if (error.message.includes('Malformed UTF-8 data')) throw new Error("当前用户已在其他设备登录，您已被登出。如需继续使用，请重新登录。")
                else throw error
            }
        } else {  
            var data = null 
            try {
                data = JSON.parse(response.data.data)
                if (data == null) throw ""
            } catch (err) {
                data = response.data                
            }
        }
        return {res:data,headers:response.headers};
        // if (data.stateCode === 200) {
        //     // console.timeLog("Request")
        //     // console.timeEnd("Request")
        //     return {res:data,headers:response.headers};
        // } else {
        //     // console.log(11);
        //     Promise.reject();
        // }
    },
    function(error) {
        console.log(error);
        return Promise.reject(error);
    }
);

export default service;
